import { render, staticRenderFns } from "./CreateRolesForTaskType.vue?vue&type=template&id=3f0d7e16&scoped=true&"
import script from "./CreateRolesForTaskType.vue?vue&type=script&lang=js&"
export * from "./CreateRolesForTaskType.vue?vue&type=script&lang=js&"
import style0 from "./CreateRolesForTaskType.vue?vue&type=style&index=0&id=3f0d7e16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0d7e16",
  null
  
)

export default component.exports